export const orderStates = {
  ALLOPEN: 'all_open',
  ACCEPTED: 'accepted',
  ASSIGNED: 'assigned',
  COMPLETE: 'complete',
  OPEN: 'open',
  INPROGRESS: 'in progress',
  LOCKED: 'locked',
  SENT: 'sent',
  STAGED: 'staged',
  CANCELED: 'canceled',
} as const

export const assignments = {
  INTERNAL: 'internal',
  ONDEMAND: 'on-demand',
  INVENTORYMANAGED: 'inventory-managed',
} as const

export const staticPriceTypes = [
  { value: 'rack', label: 'Rack' },
  { value: 'contract', label: 'Contract' },
  { value: 'index', label: 'Index' },
  { value: 'inventory', label: 'Inventory' },
  { value: 'spot', label: 'Spot' },
] as const
